import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/theme-chalk/display.css'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import './assets/css/index.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import store from "./store";
import fileArr from './components/base';
import { message } from '@/utils/resetMessage.js'


router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面meta */
	/* 路由发生变化修改页面title */
	if (to.meta.title) {
		document.title = typeof (to.meta.title) === "string" ? to.meta.title : "";
	}
	next()
});



let app = createApp(App)
// import 'amfe-flexible'
import 'vant/lib/index.css';

app.use(ElementPlus, {
	locale: zhCn,
})
app.config.globalProperties.$msg = message;
app.config.warnHandler = (msg, instance, trace) => { }
app.use(ElementPlus)
app.use(router)
app.use(store)
fileArr.forEach(item => {
	// console.log(item.name, item.compnent);
	app.component(item.name, item.compnent);   //全局注册了
})

// 解决element-plus 报错 ResizeObserver loop limit exceeded
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
	constructor(callback) {
		callback = debounce(callback, 16);
		super(callback);
	}
}
const debounce = (fn, delay) => {
	let timer = null;
	return function () {
		let context = this;
		let args = arguments;
		clearTimeout(timer);
		timer = setTimeout(function () {
			fn.apply(context, args);
		}, delay);
	}
}


app.mount('#app')
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
	app.component(key, component)
}
export const setVarStyle = (key: string, value: any, dom = document.documentElement) => {
	dom.style.setProperty(key, value)
}